<div class="ts-more-root">
    <button class="three-dots-btn"
            type="button"
            [attr.aria-expanded]="isDropdownOpen"
            aria-haspopup="true"
            aria-label="More"
            (click)="toggleDropdown($event)">
        <!-- Vertical ⋮ (Lovable PostCard MoreIcon) -->
        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" class="ts-more-trigger-icon">
            <circle cx="12" cy="5" r="1.5" />
            <circle cx="12" cy="12" r="1.5" />
            <circle cx="12" cy="19" r="1.5" />
        </svg>
    </button>

    <div *ngIf="isDropdownOpen"
         class="ts-more-backdrop"
         tabindex="-1"
         (click)="closeMenu()"></div>

    <div *ngIf="isDropdownOpen && visibleMenuItems.length > 0"
         class="ts-more-panel"
         (click)="$event.stopPropagation()">
        <ng-container *ngFor="let menuItem of visibleMenuItems">
            <button type="button"
                    class="ts-more-item"
                    [class.ts-more-item--danger]="menuItem.id === 'deletePost' || menuItem.id === 'blockUser'"
                    (click)="onMenuItemClick(menuItem.id, $event)">
                <span class="ts-more-item-icon" [innerHTML]="menuItem.svg ? menuItem.svg(context) : ''"></span>
                <span class="ts-more-item-label">{{ menuItem.text(context) }}</span>
            </button>
        </ng-container>
    </div>
</div>
